module.exports = __webpack_public_path__ + "img/GQ.d07751d7.png";